import type { ColumnDef } from "@tanstack/react-table";
import type { ApInvoice } from "@/accounts-payable/types";
import { formatCentsOrDashIfZero } from "@/core/utils/money";

export const totalCol: ColumnDef<ApInvoice> = {
  accessorKey: "total_amount_cents",
  header: "Total",
  meta: { size: "120px", align: "right" },
  cell: ({ row }) => (
    <span className="font-semibold tabular-nums">
      {formatCentsOrDashIfZero(row.original.total_amount_cents)}
    </span>
  ),
};
